import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ReplenishmentLetdownPageRBAC = {
  pageID: '30a5872b60dfcee98074879b6723bf6f',
  elementID: {
    ViewPage: 'b08236a92d6229379e04546c31c2491d',
    ActionCancelReplenish: '083b4c6845fa00dc473d09010bddb755',
    ActionAssignHelper: 'b6983903bb10b8fa82559b13d26d56de',
    ActionChangeHelper: '0b5654474342b608311814161ddce44d',
    ViewDetailReplenish: '21adfebee5ddb1faf223bd2a4870102c',
  },
} as const

export const useRBACReplenishmentLetdownPage = createUseRBAC(ReplenishmentLetdownPageRBAC.elementID)

export type UseRBACReplenishmentLetdownPageType = ReturnType<typeof useRBACReplenishmentLetdownPage>
